import React from 'react';
import { Box, Button, Icon, Tooltip } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import colors from '../../styles/theme/foundation/colors';

const GRADIENT_ID = 'pins-ai-gradient';

// an SVG icon cannot be clipped to a CSS gradient the way text can, so the same
// stops are declared as an SVG gradient the icon fills with
const GRADIENT_STOPS = [...colors.gradient.aiPrimary.matchAll(/(#[0-9a-f]{6})\s+(\d+%)/gi)]
  .map(([, color, offset]) => ({ color, offset }));

const PINSAIOutlineGradientButton = ({
  text,
  leftIcon = undefined,
  toolTip = undefined,
  variant = 'aiGradientOutline',
  ...rest
}) => (
  <Tooltip shouldWrapChildren label={toolTip}>
    <Button
      leftIcon={leftIcon && <Icon _groupHover={{ fill: 'white' }} as={leftIcon} fill={`url(#${GRADIENT_ID})`} />}
      mt={4}
      role="group"
      variant={variant}
      w="100%"
      {...rest}
    >
      {leftIcon && (
        <svg aria-hidden="true" height="0" style={{ position: 'absolute' }} width="0">
          <defs>
            <linearGradient id={GRADIENT_ID} x1="0" x2="1" y1="0" y2="1">
              {GRADIENT_STOPS.map(stop => <stop key={stop.offset} offset={stop.offset} stopColor={stop.color} />)}
            </linearGradient>
          </defs>
        </svg>
      )}
      <Box
        _groupHover={{
          backgroundImage: colors.gradient.aiPrimary,
          color: 'inherit',
          _disabled: {
            bgClip: 'text',
            bgGradient: colors.gradient.aiPrimary,
            color: 'rgba(214, 48, 228, 0.1)'
          }
        }}
        bgClip="text"
        bgGradient={colors.gradient.aiPrimary}
        transition="all .3s ease"
      >
        {text}
      </Box>
    </Button>
  </Tooltip>
);

PINSAIOutlineGradientButton.propTypes = {
  text: PropTypes.string.isRequired,
  toolTip: PropTypes.string,
  leftIcon: PropTypes.elementType,
  variant: PropTypes.string
};

export default PINSAIOutlineGradientButton;
